(function ($) {
    'use strict';
    $(document).ready(function () {
        $("#sylius_product_variant_sizes").change(function () {
            var value = $(this).val();
            if (!value) {
                $("#shipping-properties").show();
                $("#shipping-properties input").removeAttr('readonly', '');
                return;
            }

            // $("#shipping-properties").hide();
            $("#shipping-properties input").attr('readonly', 'readonly');

            var sizes = JSON.parse(value);

            $("#sylius_product_variant_width").val(sizes[0]);
            $("#sylius_product_variant_height").val(sizes[1]);
            $("#sylius_product_variant_depth").val(sizes[2]);
            $("#sylius_product_variant_weight").val(sizes[3]);
        });

        var options = $('#sylius_product_variant_sizes option');

        options.each(function (i, option) {
            var value = $(option).val();
            if (!value) {
                return;
            }

            var sizes = JSON.parse(value);

            if (
                $("#sylius_product_variant_width").val() == sizes[0] &&
                $("#sylius_product_variant_height").val() == sizes[1] &&
                $("#sylius_product_variant_depth").val() == sizes[2] &&
                $("#sylius_product_variant_weight").val() == sizes[3]
            ) {
                $('#sylius_product_variant_sizes').val(value);
            }
        });
    });
})(jQuery);
